export const panoramas = [
  {
    id: '329',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.41,1.06&ss=21',
  },
  {
    id: '333',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-1.99,1.18&ss=22',
  },
  {
    id: '336',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.29,1.18&ss=23',
  },
  {
    id: '123',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.61,-1.07&ss=19',
  },
  {
    id: '124',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.59,.93&ss=20',
  },
  {
    id: '56',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.87,-.28&ss=12',
  },
  {
    id: '57',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-1.28,-1.3&ss=13',
  },
  {
    id: '58',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.44,-.86&ss=14',
  },
  {
    id: '59',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-1.28,-1.27&ss=15',
  },
  {
    id: '60',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.69,-1.06&ss=16',
  },
  {
    id: '16',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.33,-.47&ss=17',
  },
  {
    id: '17',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.29,-.69&ss=18',
  },
  {
    id: '18',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.29,-.69&ss=18',
  },
  {
    id: '19',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.28,-.18&ss=27',
  },
  {
    id: '20',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.29,.03&ss=28',
  },
  {
    id: '21',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.29,.03&ss=28',
  },
  {
    id: '23',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.29,.22&ss=29',
  },
  {
    id: '31',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.41,.65&ss=30',
  },
  {
    id: '32',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.37,.49&ss=31',
  },
  {
    id: '33',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.76,1.17&ss=33',
  },
  {
    id: '34',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.73,1.17&ss=34',
  },
  {
    id: '35',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-.41,.93&ss=37',
  },
  {
    id: '36',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-1.52,1.28&ss=36',
  },
  {
    id: '37',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.64,1.13&ss=38',
  },
  {
    id: '38',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.11,1.24&ss=39',
  },
  {
    id: '39',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.8,.78&ss=40',
  },
  {
    id: '1',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.8,.78&ss=40',
  },
  {
    id: '2',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.84,.84&ss=41',
  },
  {
    id: '3',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.84,.84&ss=41',
  },
  {
    id: '4',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.84,.84&ss=41',
  },
  {
    id: '5',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.83,.53&ss=4',
  },
  {
    id: '6',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.9,-.38&ss=5',
  },
  {
    id: '7',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.9,-.38&ss=5',
  },
  {
    id: '8',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.87,-.5&ss=6',
  },
  {
    id: '51',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.9,-.16&ss=8',
  },
  {
    id: '53',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.87,-.77&ss=9',
  },
  {
    id: '54',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.56,-.92&ss=10',
  },
  {
    id: '55',
    view: 'https://my.matterhub.ru/8/9oW6Wha97zd/?m=9oW6Wha97zd&sr=-2.63,-.94&ss=11',
  },
  {
    id: '46',
    view: 'https://ep.matterport.host/index/?m=9oW6Wha97zd&ss=26&sr=.03,-.98',
  },
  {
    id: '9',
    view: 'https://ep.matterport.host/index/?m=9oW6Wha97zd&ss=26&sr=.03,-.98',
  },
];
